import { dialogs } from '@Containers/Dialogs/DialogsSelectors';

// eslint-disable-next-line import/prefer-default-export
export function showMore(state, ownProps) {
  const { id } = ownProps;

  return dialogs(state).getIn([id, 'showMore']);
}
